var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M15.5 11.992a.6.6 0 0 0-.193-.473l-5.651-5.35A.7.7 0 0 0 9.179 6a.7.7 0 0 0-.469.19.63.63 0 0 0-.2.443.63.63 0 0 0 .18.452l5.19 4.908-5.19 4.912a.63.63 0 0 0-.19.454.63.63 0 0 0 .2.451c.127.12.298.188.477.19a.7.7 0 0 0 .48-.18l5.649-5.35a.63.63 0 0 0 .193-.477"
})));
export default SvgArrowRight;